/**
 * Starts the registry API request before the ES module loads.
 */
(function () {
  const REGISTRY_UUID_RE =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const ITEMS_PER_PAGE = 10;
  const REGISTRY_END_POINT = '/apps/club/api/proxy/registry';

  function getRegistryId() {
    const segment = window.location.pathname.split('/').pop() || '';
    return REGISTRY_UUID_RE.test(segment) ? segment : '';
  }

  function getPage() {
    return parseInt(localStorage.getItem('currentPage'), 10) || 1;
  }

  function prefetchKey(registryId, page, limit) {
    return `${registryId}:${page}:${limit}`;
  }

  function fetchRegistry(registryId, page, limit = ITEMS_PER_PAGE) {
    const key = prefetchKey(registryId, page, limit);
    const cache = window.__boaRegistryPrefetch;

    if (cache && cache.key === key) {
      return cache.promise;
    }

    const promise = fetch(`${REGISTRY_END_POINT}/${registryId}?page=${page}&limit=${limit}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }).then((response) => {
      if (!response.ok) {
        throw new Error('registry fetch failed');
      }
      return response.json();
    });

    window.__boaRegistryPrefetch = { key, promise };
    return promise;
  }

  function invalidatePrefetch() {
    delete window.__boaRegistryPrefetch;
  }

  function clearLegacyRegistryCache() {
    try {
      for (let index = sessionStorage.length - 1; index >= 0; index -= 1) {
        const key = sessionStorage.key(index);
        if (key && key.startsWith('boa_registry_v')) {
          sessionStorage.removeItem(key);
        }
      }
    } catch {
      /* ignore */
    }
  }

  const registryId = getRegistryId();
  if (registryId) {
    clearLegacyRegistryCache();
    fetchRegistry(registryId, getPage(), ITEMS_PER_PAGE);
  }

  window.BoaBabyRegistryBootstrap = {
    fetchRegistry,
    getRegistryId,
    getPage,
    invalidatePrefetch,
    clearLegacyRegistryCache,
    ITEMS_PER_PAGE,
  };
})();
